import queryString from 'query-string';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { employeesStateForOrgIdAndStatusSelector } from '../../reducers/employee-selectors';

import * as Api from '../../api/api';

export const EMPLOYEE_STATUS = {
  CURRENT: 'CURRENT',
  FORMER: 'FORMER',
} as const;

export type EmployeeStatus = ValueOf<typeof EMPLOYEE_STATUS>;

export const loadOrgEmployeesByStatus = (orgId: number, employeeStatus: EmployeeStatus) =>
  createGenericDispatcher({
    name: 'LOAD_ORG_EMPLOYEES_BY_STATUS',
    loadFunction: () =>
      Api.get(
        `/org/${orgId}/employees${
          employeeStatus ? `?${queryString.stringify({ employeeStatus })}` : ''
        }`,
      ),
    args: { orgId, employeeStatus },
    shouldExecuteSelector: (state: any) =>
      employeesStateForOrgIdAndStatusSelector(state, orgId, employeeStatus),
  });
